import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { AdminGuard } from './guards/admin.guard';

const routes: Routes = [
  { path: 'checkin', loadChildren: (): Promise<any> => import('./modules/checkin/checkin.module').then((m: any): void => m.CheckinModule) },
  { path: 'conciergerie/admin', loadChildren: (): Promise<any> => import('./modules/admin/admin.module').then((m: any): void => m.AdminModule), canActivate: [AuthGuard, AdminGuard] },
  { path: 'conciergerie', loadChildren: (): Promise<any> => import('./modules/conciergerie/conciergerie.module').then((m: any): void => m.ConciergerieModule) },
  { path: 'user', loadChildren: (): Promise<any> => import('./modules/user/user.module').then((m: any): void => m.UserModule), canActivate: [AuthGuard] },
  { path: '', loadChildren: (): Promise<any> => import('./modules/guest/guest.module').then((m: any): void => m.GuestModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
